const convertMsToMin = (milliseconds: number) => {
  return Math.round(Number(milliseconds) * 1.67 * Math.pow(10, -5));
};

export default convertMsToMin;
